module.exports = __webpack_public_path__ + "img/W7.9d7a80f1.png";